import React from 'react';
import PropTypes from 'prop-types';
import * as commonLogic from '../../../logic/CommonLogic';

const NumberStyle = { color: 'var(--color-scheme-col-minus)' };

/**
 * MainGridMiddleRightRowDayOnTypeSlot
 */
class MainGridMiddleRightRowDayOnTypeSlot extends React.Component {

  render() {
    // 納品開始日
    let nohinkaishibi = dispDataFormatSlash(this.props.dataDayOnItem.nohinkaishibi);

    // アウト
    let stringItem1 = '-';
    if (this.props.dataDayOnItem.koumoku1 !== '') {
      stringItem1 = commonLogic.numberFormat(this.props.dataDayOnItem.koumoku1, 0);

    }

    // 台売上
    let stringItem2 = '-';
    if (this.props.dataDayOnItem.koumoku2 !== '') {
      stringItem2 = commonLogic.numberFormat(this.props.dataDayOnItem.koumoku2, 0);
    }

    // 台粗利
    let stringItem3 = '-';
    if (this.props.dataDayOnItem.koumoku3 !== '') {
      stringItem3 = commonLogic.numberFormat(this.props.dataDayOnItem.koumoku3, 0);
    }

    // メダル単価
    let stringItem4 = '-';
    if (this.props.dataDayOnItem.koumoku4 !== '') {
      stringItem4 = commonLogic.numberFormat(this.props.dataDayOnItem.koumoku4, 2);
    }

    // メダル粗利
    let stringItem5 = '-';
    if (this.props.dataDayOnItem.koumoku5 !== '') {
      stringItem5 = commonLogic.numberFormat(this.props.dataDayOnItem.koumoku5, 2);
    }

    // 中古価格
    let stringItem6 = '-';
    let stringItem6Style = null;
    if (this.props.dataDayOnItem.koumoku6 !== '' && this.props.dataDayOnItem.koumoku6 !== 0) {
      stringItem6 = commonLogic.numberFormat(this.props.dataDayOnItem.koumoku6, 0);
      if (parseFloat(stringItem6) < 0) {
        stringItem6Style = 'minus_value';
      }
    }
    // 中古価格の機種コード(p-sensor機種コード)
    let kisyuCd = '';
    const psensorInfo = this.props.dataDayOnItem.p_sensor;
    if (psensorInfo !== undefined) {
      kisyuCd = psensorInfo.kisyu_cd;
    }

    // 中古価格増減
    let stringItem7 = '-';
    if (this.props.dataDayOnItem.koumoku7 !== '') {
      if (this.props.dataDayOnItem.koumoku7 != undefined && this.props.dataDayOnItem.koumoku7 != 0) {
        stringItem7 = commonLogic.numberFormat(this.props.dataDayOnItem.koumoku7, 0);
        if (0 < parseInt(stringItem7.replace(/,/g, ''), 10)) {
          stringItem7 = '+' + stringItem7;
        }
      } else {
        stringItem7 = String(0);
      }
    }
    function formatItemYen(s) {
      if (s === '-') return <p>{s}</p>;
      if (s.startsWith("+")) return <p>+&yen;{s.slice(1)}</p>;
      if (s.startsWith("-")) return <p style={NumberStyle}>-&yen;{s.slice(1)}</p>;
      return <p className="noto-sans-text">&plusmn;&yen;{s}</p>;
    }

    // 平気設置台数
    let stringItem8 = '-';
    if (this.props.dataDayOnItem.koumoku8 !== '') {
      stringItem8 = commonLogic.numberFormat(this.props.dataDayOnItem.koumoku8, 2);
    }

    // 平均段階設定
    let stringItem9 = '-';
    if (this.props.dataDayOnItem.koumoku9 !== '') {
      stringItem9 = commonLogic.numberFormat(this.props.dataDayOnItem.koumoku9, 2);
    }

    // 出玉率
    let stringItem10 = '-';
    if (this.props.dataDayOnItem.koumoku10 !== '') {
      stringItem10 = commonLogic.numberFormat(this.props.dataDayOnItem.koumoku10, 2);
    }

    // 50枚ゲーム数
    let stringItem11 = '-';
    if (this.props.dataDayOnItem.koumoku11 !== '') {
      stringItem11 = commonLogic.numberFormat(this.props.dataDayOnItem.koumoku11, 0);
    }

    // TY
    let stringItem12 = '-';
    if (this.props.dataDayOnItem.koumoku12 !== '') {
      stringItem12 = commonLogic.numberFormat(this.props.dataDayOnItem.koumoku12, 0);
    }

    // 最大出玉数
    let stringItem13 = '-';
    if (this.props.dataDayOnItem.koumoku13 !== '') {
      stringItem13 = commonLogic.numberFormat(this.props.dataDayOnItem.koumoku13, 0);
    }

    // 最大吸込数
    let stringItem14 = '-';
    if (this.props.dataDayOnItem.koumoku14 !== '') {
      stringItem14 = commonLogic.numberFormat(this.props.dataDayOnItem.koumoku14, 0);
    }

    // 客滞率
    let stringItem15 = '-';
    if (this.props.dataDayOnItem.koumoku15 !== '') {
      stringItem15 = commonLogic.numberFormat(this.props.dataDayOnItem.koumoku15, 2);
    }

    // メーカー
    let stringItem16 = '-';
    if (this.props.dataDayOnItem.koumoku16 !== '') {
      stringItem16 = this.props.dataDayOnItem.koumoku16;
    }

    // タイプ
    let stringItem17 = '-';
    if (this.props.dataDayOnItem.koumoku17 !== '') {
      stringItem17 = this.props.dataDayOnItem.koumoku17;
    }

    // 設置台数
    let stringItem18 = '-';
    if (this.props.dataDayOnItem.koumoku18 !== '') {
      stringItem18 = commonLogic.numberFormat(this.props.dataDayOnItem.koumoku18, 0);
    }

    let stringRow = this.props.dataDayOnItem.cnt;
    let stringClass;

    if (stringRow == 1) {
      stringClass = 'row1 highlight';
    } else {
      stringClass = 'row' + stringRow;
    }

    let rowName = stringClass;

    return (
      <div className="border_b">
        <div className={rowName}>
          <div className="col2 sheet_data ib vm border_r col_koumoku">
            <p>{nohinkaishibi}</p>
          </div>
          <div className="col3 sheet_data ib vm border_r col_koumoku">
            {stringItem1.match('-') && stringItem1 != '-' ? (<p style={NumberStyle}>{stringItem1}</p>) : (<p>{stringItem1}</p>)}
          </div>
          <div className="col4 sheet_data ib vm border_r col_koumoku">
            {stringItem2.match('-') && stringItem2 != '-' ? (<p style={NumberStyle}>{stringItem2}</p>) : (<p>{stringItem2}</p>)}
          </div>
          <div className="col5 sheet_data ib vm border_r col_koumoku">
            {stringItem3.match('-') && stringItem3 != '-' ? (<p style={NumberStyle}>{stringItem3}</p>) : (<p>{stringItem3}</p>)}
          </div>
          <div className="col6 sheet_data ib vm border_r col_koumoku">
            {stringItem4.match('-') && stringItem4 != '-' ? (<p style={NumberStyle}>{stringItem4}</p>) : (<p>{stringItem4}</p>)}
          </div>
          <div className="col7 sheet_data ib vm border_r col_koumoku">
            {stringItem5.match('-') && stringItem5 != '-' ? (<p style={NumberStyle}>{stringItem5}</p>) : (<p>{stringItem5}</p>)}
          </div>
          <div className="col8 sheet_data ib vm border_r col_koumoku">
            {stringItem6 != '-' ? (
              <a className={`used_machine_price ${stringItem6Style}`} href="#" onClick={(event) => { commonLogic.handleUsedMachinePriceClick(event, kisyuCd); }}>&yen;{stringItem6}</a>
            ) : (
              <a className="used_machine_price" href="#" onClick={(event) => { commonLogic.handleUsedMachinePriceClick(event, kisyuCd); }}>{stringItem6}</a>
            )}
          </div>
          <div className="col9 sheet_data ib vm border_r col_koumoku">
            {formatItemYen(stringItem7)}
          </div>
          <div className="col10 sheet_data ib vm border_r col_koumoku">
            {stringItem8.match('-') && stringItem8 != '-' ? (<p style={NumberStyle}>{stringItem8}</p>) : (<p>{stringItem8}</p>)}
          </div>
          <div className="col11 sheet_data ib vm border_r col_koumoku">
            {stringItem9.match('-') && stringItem9 != '-' ? (<p style={NumberStyle}>{stringItem9}</p>) : (<p>{stringItem9}</p>)}
          </div>
          <div className="col12 sheet_data ib vm border_r col_koumoku">
            {stringItem10.match('-') && stringItem10 != '-' ? (<p style={NumberStyle}>{stringItem10}</p>) : (<p>{stringItem10}</p>)}
          </div>
          <div className="col13 sheet_data ib vm border_r col_koumoku">
            {stringItem11.match('-') && stringItem11 != '-' ? (<p style={NumberStyle}>{stringItem11}</p>) : (<p>{stringItem11}</p>)}
          </div>

          <div className="col14 sheet_data ib vm border_r col_koumoku">
            {stringItem12.match('-') && stringItem12 != '-' ? (<p style={NumberStyle}>{stringItem12}</p>) : (<p>{stringItem12}</p>)}
          </div>

          <div className="col15 sheet_data ib vm border_r col_koumoku">
            {stringItem13.match('-') && stringItem13 != '-' ? (<p style={NumberStyle}>{stringItem13}</p>) : (<p>{stringItem13}</p>)}
          </div>

          <div className="col16 sheet_data ib vm border_r col_koumoku">
            {stringItem14.match('-') && stringItem14 != '-' ? (<p style={NumberStyle}>{stringItem14}</p>) : (<p>{stringItem14}</p>)}
          </div>

          <div className="col17 sheet_data ib vm border_r col_koumoku">
            {stringItem15.match('-') && stringItem15 != '-' ? (<p style={NumberStyle}>{stringItem15}</p>) : (<p>{stringItem15}</p>)}
          </div>

          <div className="col18 sheet_data ib vm border_r col_koumoku">
            <p className="grid_string" title={stringItem16}>{stringItem16}</p>
          </div>

          <div className="col19 sheet_data ib vm border_r col_koumoku">
            <p className="grid_string" title={stringItem17}>{stringItem17}</p>
          </div>

          <div className="col20 sheet_data ib vm border_r col_koumoku">
            {stringItem18.match('-') && stringItem18 != '-' ? (<p style={NumberStyle}>{stringItem18}</p>) : (<p>{stringItem18}</p>)}
          </div>
        </div>
      </div>
    );
  }
}
MainGridMiddleRightRowDayOnTypeSlot.propTypes = {
  dataDayOnItem: PropTypes.any.isRequired,
  actions: PropTypes.any.isRequired,
};

export default MainGridMiddleRightRowDayOnTypeSlot;
